var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.6C0 6.23969 0 4.55953 0.653961 3.27606C1.2292 2.14708 2.14708 1.2292 3.27606 0.653961C4.55953 0 6.23969 0 9.6 0H14.4C17.7603 0 19.4405 0 20.7239 0.653961C21.8529 1.2292 22.7708 2.14708 23.346 3.27606C24 4.55953 24 6.23969 24 9.6V14.4C24 17.7603 24 19.4405 23.346 20.7239C22.7708 21.8529 21.8529 22.7708 20.7239 23.346C19.4405 24 17.7603 24 14.4 24H9.6C6.23969 24 4.55953 24 3.27606 23.346C2.14708 22.7708 1.2292 21.8529 0.653961 20.7239C0 19.4405 0 17.7603 0 14.4V9.6Z",
    fill: "white",
    fillOpacity: 0.01
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1859_11762)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9897 11.9991C17.2778 12.03 17.4862 12.289 17.4555 12.5773C17.2762 14.2591 16.3231 15.8377 14.7445 16.7491C12.3264 18.1452 9.28815 17.4888 7.642 15.3224L7.54825 15.6749C7.47309 15.9548 7.18467 16.12 6.90469 16.045C6.62489 15.9698 6.45866 15.6824 6.5336 15.4024L6.96036 13.8087L6.97696 13.7579C7.07146 13.5093 7.34142 13.3673 7.60391 13.4376L9.19766 13.8644C9.4776 13.9394 9.64369 14.2279 9.56876 14.5079C9.49369 14.7877 9.20604 14.9537 8.92618 14.879L8.5463 14.7765C9.89202 16.4562 12.2988 16.9492 14.2201 15.8399C15.4957 15.1033 16.2664 13.8284 16.4115 12.4659C16.4422 12.1777 16.7014 11.9686 16.9897 11.9991ZM9.26114 7.25108C11.6791 5.85515 14.7175 6.51176 16.3637 8.67784L16.4574 8.32628C16.5325 8.04627 16.821 7.87928 17.101 7.9542C17.3811 8.02925 17.5471 8.31769 17.4721 8.59776L17.0453 10.1915C17.0093 10.3257 16.9214 10.4403 16.8012 10.5099C16.6807 10.5794 16.5371 10.5985 16.4027 10.5626L14.809 10.1349C14.529 10.0599 14.3621 9.77227 14.4369 9.49229C14.5121 9.21239 14.8005 9.04618 15.0805 9.1212L15.4584 9.22178C14.1124 7.54348 11.7072 7.05243 9.78653 8.16124C8.51071 8.89792 7.73919 10.1726 7.59415 11.5353C7.56325 11.8233 7.30412 12.0316 7.01602 12.0011C6.72794 11.9703 6.51966 11.7121 6.5502 11.4239C6.72924 9.74186 7.68235 8.16266 9.26114 7.25108Z",
    fill: "#5BA8F5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1859_11762"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.55443418b7eed56fe3535a1238c0d5a4.svg";
export { ForwardRef as ReactComponent };